var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavDocuments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18769 1.86554C3.52109 1.52457 3.97327 1.33301 4.44477 1.33301H9.18551C9.34268 1.33301 9.4934 1.39686 9.60454 1.51052L13.1601 5.14688C13.2712 5.26054 13.3337 5.41469 13.3337 5.57543V12.8482C13.3337 13.3304 13.1464 13.7928 12.813 14.1338C12.4796 14.4748 12.0274 14.6663 11.5559 14.6663H4.44477C3.97327 14.6663 3.52109 14.4748 3.18769 14.1338C2.85429 13.7928 2.66699 13.3304 2.66699 12.8482V3.15119C2.66699 2.66898 2.85429 2.20652 3.18769 1.86554ZM4.44477 2.54513C4.2876 2.54513 4.13688 2.60898 4.02574 2.72264C3.91461 2.8363 3.85218 2.99045 3.85218 3.15119V12.8482C3.85218 13.0089 3.91461 13.1631 4.02574 13.2767C4.13688 13.3904 4.2876 13.4542 4.44477 13.4542H11.5559C11.713 13.4542 11.8638 13.3904 11.9749 13.2767C12.086 13.1631 12.1485 13.0089 12.1485 12.8482V5.82647L8.94005 2.54513H4.44477Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18551 1.33301C9.51279 1.33301 9.7781 1.60435 9.7781 1.93907V4.96937H12.7411C13.0683 4.96937 13.3337 5.24071 13.3337 5.57543C13.3337 5.91015 13.0683 6.18149 12.7411 6.18149H9.18551C8.85823 6.18149 8.59292 5.91015 8.59292 5.57543V1.93907C8.59292 1.60435 8.85823 1.33301 9.18551 1.33301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03736 8.60574C5.03736 8.27102 5.30268 7.99967 5.62995 7.99967H10.3707C10.698 7.99967 10.9633 8.27102 10.9633 8.60574C10.9633 8.94045 10.698 9.2118 10.3707 9.2118H5.62995C5.30268 9.2118 5.03736 8.94045 5.03736 8.60574Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03736 11.03C5.03736 10.6953 5.30268 10.4239 5.62995 10.4239H10.3707C10.698 10.4239 10.9633 10.6953 10.9633 11.03C10.9633 11.3647 10.698 11.636 10.3707 11.636H5.62995C5.30268 11.636 5.03736 11.3647 5.03736 11.03Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03736 6.18149C5.03736 5.84677 5.30268 5.57543 5.62995 5.57543H6.81514C7.14242 5.57543 7.40773 5.84677 7.40773 6.18149C7.40773 6.51621 7.14242 6.78755 6.81514 6.78755H5.62995C5.30268 6.78755 5.03736 6.51621 5.03736 6.18149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDocuments);
export default __webpack_public_path__ + "static/media/nav-documents.ed9ddd16e0b13dacffcd9dd228a39e8b.svg";
export { ForwardRef as ReactComponent };